module.exports = __webpack_public_path__ + "amcharts/images/dragIconRoundSmallBlack.png";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/dragIconRoundSmallBlack.png
// module id = 256
// module chunks = 0